var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 26.3334C12.5529 26.3334 13.0007 25.8857 13.0007 25.3334C13.0007 24.7811 12.5529 24.3334 12.0007 24.3334H6.66732C4.2753 24.3304 2.33692 22.3921 2.33398 20V6.66671C2.33692 4.27469 4.2753 2.33631 6.66732 2.33337H12.0007C12.5529 2.33337 13.0007 1.88566 13.0007 1.33337C13.0007 0.781089 12.5529 0.333374 12.0007 0.333374H6.66732C3.17134 0.337782 0.338392 3.17073 0.333984 6.66671V20C0.338392 23.496 3.17134 26.329 6.66732 26.3334H12.0007ZM18.0407 7.29337L23.374 12.6267C23.5617 12.8143 23.6671 13.0687 23.6671 13.334C23.6671 13.5994 23.5617 13.8538 23.374 14.0414L18.0407 19.3747C17.6481 19.7535 17.0244 19.7478 16.6388 19.3619C16.2533 18.976 16.2482 18.3522 16.6273 17.96L20.2527 14.3334H9.33398C8.7817 14.3334 8.33398 13.8857 8.33398 13.3334C8.33398 12.7811 8.7817 12.3334 9.33398 12.3334H20.2527L16.6273 8.70804C16.3672 8.45709 16.2628 8.08534 16.3542 7.73566C16.4455 7.38599 16.7184 7.11282 17.068 7.02114C17.4176 6.92946 17.7895 7.03354 18.0407 7.29337Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.eefc498d.svg";
export { ForwardRef as ReactComponent };